import { configureStore } from "@reduxjs/toolkit";
import user from "./slices/user";

const reHydrateStore = () => {
  if (localStorage.getItem("token") !== null) {
    const token = localStorage.getItem("token");
    const permissions = localStorage.getItem("permissions");
    const roles = localStorage.getItem("roles");
    const organizations = localStorage.getItem("organizations");
    const resolvedPermissions = localStorage.getItem("resolvedPermissions");
    return {
      user: {
        token: token,
        authenticated: token ? true : false,
        permissions: JSON.parse(permissions),
        roles: JSON.parse(roles),
        organizations: JSON.parse(organizations),
        resolvedPermissions: resolvedPermissions
          ? JSON.parse(resolvedPermissions)
          : null,
      },
    };
  }
};

const store = configureStore({
  reducer: {
    user: user,
  },
  preloadedState: reHydrateStore(),
});

export default store;
